import { useHistory } from "react-router-dom";

/**
 * React Router v5 compat for v6's useNavigate (cloned MiniGame module).
 * @returns {(to?: string | number, options?: { replace?: boolean }) => void}
 */
export function useNavigate() {
  const history = useHistory();

  return (to, options) => {
    if (to === undefined || to === null) {
      history.goBack();
      return;
    }
    if (typeof to === "number") {
      if (to === -1) {
        history.goBack();
      } else {
        history.go(to);
      }
      return;
    }
    if (options?.replace) {
      history.replace(to);
    } else {
      history.push(to);
    }
  };
}
